"use client";
import { useDispatch, useSelector } from "react-redux";
import { Box, ButtonIcon, Icon, Input, Text } from "@quintoandar-tokko/jopijs";
import style from "../fichaInfo.module.scss";
import translations from "../FichaInfo.trans.json";
import Trans from "@/components/shared/Trans";
import { setEditedData } from "@/store/slices/components/fichaInfo/FichaInfoSlice";
import Skeleton from "../skelenton/Skeleton";
import { handleLinkClick } from "../utilities/helpers";

export default function TitleProperty() {
  const dispatch = useDispatch();
  const state = useSelector((ste) => ste.FichaInfoSlice);
  const { isEdition, showData, edited_data, loading, for_colleague, is_from_network } = state;
  const { has_edition, title, show_location } = edited_data;

  const scrollToBottom = (reset) => {
    const bodyDescription = document.getElementById(
      "fichaInfo_propertyDescription"
    );
    window.scrollTo({
      top: reset ? 0 : bodyDescription.scrollHeight,
      behavior: "smooth",
    });
  };

  const handleAddresChange = (e) => {
    dispatch(setEditedData({ key: "title", value: e.target.value }));
  };
  const status = {
    4: "NotAvailable",
    2: "Available",
    3: "Reserved",
    1: "Appraisal",
  };

  const handleBadges = (constructionStatus, deadLine) => {
    if (for_colleague || is_from_network) return null;
    return (
      <Box className={style.badgeCont}>
        {state.origin_data?.development?.web && (
          <ButtonIcon
            variant="mainButton"
            icon="icon-sitioweb"
            className={style.webDevBtn}
            text={state.origin_data.development.web}
            fontSize="12px"
            onClick={() => handleLinkClick(state.origin_data.development.web)}
          />
        )}
        <Box __css={{ display: "flex", gap: "8px" }}>
          <Box
            __css={{ borderColor: "#C1B2F3", backgroundColor: "#EFEBFF" }}
            as="span"
            className={style.badgeDevInfo}
          >
            {constructionStatus}
          </Box>
          {deadLine && (
            <Box
              __css={{ borderColor: "var(--colors-neutral-grey-400)", backgroundColor: "var(--colors-surface-secondary-low)" }}
              as="span"
              className={style.badgeDevInfo}
            >
              {Trans(translations, "DeliveredDate")} {deadLine}
            </Box>
          )}
        </Box>
      </Box>
    );
  };

  if (loading)
    return (
      <Box className={style.titlePropertyContainer}>
        <Box __css={{ display: "flex", gap: "16px" }}>
          <Skeleton width={250} height={28} borderRadius={50} />
        </Box>
        <Skeleton width={200} height={20} borderRadius={50} />
        <Skeleton width={300} height={18} borderRadius={50} />
      </Box>
    );

  return !isEdition && !loading ? (
    <Box className={style.titlePropertyContainer}>
      {!loading && (
        <Box
          className={`${style.statusContainer} ${
            !state.origin_data.development &&
            style[status[state.origin_data.status.id]]
          }`}
          variant="bodyBold.fontSize14"
        >
          {state.origin_data.status.id === 3 && (
            <Box className={style.propertyReservedContainer}>
              <Text> {Trans(translations, "PropertyReserved")}</Text>
            </Box>
          )}

          <Text
            color="var(--colors-neutral-grey-700)"
            variant="body.fontSize14"
          >{`${state.origin_data.reference} | ${state.origin_data.type.name}`}</Text>
        </Box>
      )}
      <Text className={style.title} variant="bodyBold.fontSize24">
        {state[showData][showData === "origin_data" ? "address" : "title"]}
      </Text>
      <Box __css={{ display: "flex", gap: "16px" }}>
        <Text className={style.address} variant="body.fontSize14">
          {state.origin_data.location}
        </Text>
        {(showData === "origin_data" || show_location) && (
          <Box
            className={style.seeMap}
            as="span"
            onClick={() => scrollToBottom(false)}
          >
            <Icon icon="icon-ubicacion" fontSize="16px" />
            <Text variant="bodyBold.fontSize12">
              {Trans(translations, "ViewMap")}
            </Text>
          </Box>
        )}
      </Box>
      {state.origin_data.development && (
        <Box className={style.devInfo} __css={{ marginTop: "8px" }}>
          {handleBadges(
            state.origin_data.development.construction_status,
            state.origin_data.development.deadline
          )}
        </Box>
      )}
    </Box>
  ) : (
    <Box className={style.addressInputContainer}>
      <Input
        data-testid="address-input"
        label={Trans(translations, "Address")}
        width="100%"
        onChange={handleAddresChange}
        maxLength="250"
        value={title}
        defaultValue={!has_edition ? state.origin_data.address : title}
      />
    </Box>
  );
}
